import PreferitiItemAuth from './components/preferitiItemAuth'
import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import AuthProvider from '../Authentication/authProvider'
import axios from 'axios'
import { useEffect, useState } from 'react'
import DivBottom from '../../page/userNotAuth/components/divBottom'
import { useNavigate, useLocation } from 'react-router-dom'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'

function Preferiti() {
    const navigate = useNavigate()
    const idUser = localStorage.getItem('id')
    const [preferiti, setPreferiti] = useState(null)
    const [msg, setMsg] = useState({ noPreferiti: null })

    useEffect(() => {
        try {
            axios.get(`/getPreferitiById/${idUser}`).then(
                res => {
                    console.log('res.data:', res.data)
                    if (res.data.filter(item => (item[0].accettazione === 'true' || item[0].accettazione === 'null')).length === 0) {
                        setMsg({
                            noPreferiti: 'Non hai eventi preferiti salvati'
                        })
                    } else
                        setPreferiti(res.data)
                })
        } catch (err) { console.log(err) }
    }, [])
    return (<>
        <AuthProvider />
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        <br /><br />
        <div className='container' style={{ marginTop: '5rem' }}>
            <h3 style={{
                color: 'navy', marginTop: '1rem', textAlign: 'center'
            }}>I TUOI EVENTI...PREFERITI</h3>
            <p style={{ opacity: '0.7', textAlign: 'center' }}>EVENTI SALVATI</p>
        </div>
        <hr />
        {msg.noPreferiti &&
            <h4 className='text-center mt-5' style={{
                marginBottom: '8rem'
            }}>{msg.noPreferiti}
            </h4>
        }
        <div className='container' style={{ marginBottom: '1rem' }}>
            <div className="row row-cols-1 row-cols-md-3 g-4">
                {preferiti && preferiti
                    .filter(evento => evento[0].accettazione !== 'false')
                    .filter(evento => evento[0].accettazione !== 'rejection')
                    .map((item, index) => (
                        <PreferitiItemAuth
                            key={item[0].id}
                            id={item[0].id}
                            userId={item[0].userId}
                            accettazione={item[0].accettazione}
                            città={item[0].città}
                            comune={item[0].comune}
                            provincia={item[0].provincia}
                            dataInizio={item[0].dataInizio}
                            dataFine={item[0].dataFine}
                            descrizione={item[0].descrizione}
                            opzioniBiglietto={item[0].opzioniBiglietto}
                            oraFine={item[0].oraFine}
                            oraInizio={item[0].oraInizio}
                            prezzo={item[0].prezzo}
                            tipologia={item[0].tipologia}
                            titolo={item[0].titolo}
                            img={item[0].img}
                            view={item[0].view}
                        />
                    ))}
            </div>
        </div>
        <div className='container'>
            <button className='btn btn-secondary' onClick={
                () => {
                    navigate('/', { replace: true })
                }}>Indietro</button>
        </div>
        <br /><br />
        <DivBottom />
    </>)
}
export default Preferiti